import currency from 'currency.js';
import { IBettingLimits } from '@bg-shared/business/BettingLimits/interfaces';

export const findNextInSequence = (
    amount: number,
    sequence: number[],
    limit: IBettingLimits | null,
    reverse: boolean,
): number => {
    // shallow Copy and sort increasing
    const sortedSeq = sequence.slice().sort((a, b) => a - b);

    // if sequence will be [0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 25, 50, 100, 200]
    // and limits be : { min: 0.2, max: 100 }
    // the following make the sequence to :  [0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 25, 50, 100, 200, 400, 600, 800]

    if (limit && sortedSeq[sortedSeq.length - 1] * 2 < limit.max) {
        const increment = sortedSeq[sortedSeq.length - 1];

        while (sortedSeq[sortedSeq.length - 1] + increment < limit.max) {
            sortedSeq.push(sortedSeq[sortedSeq.length - 1] + increment);
        }
    }

    const maximumAllowed = limit?.max || sortedSeq[sortedSeq.length - 1];
    const minimumAllowed = limit?.min || sortedSeq[0];

    if (amount > maximumAllowed) {
        return maximumAllowed;
    }

    if (amount < minimumAllowed) {
        return minimumAllowed;
    }

    const filteredSeq = sortedSeq.filter(
        (seqNum) => seqNum <= maximumAllowed && seqNum >= minimumAllowed,
    );

    if (reverse) {
        const nextValue = filteredSeq
            .reverse()
            .find((seq) => currency(amount).subtract(seq).value > 0);

        return nextValue || minimumAllowed;
    }

    const nextValue = filteredSeq.find((seq) => currency(seq).subtract(amount).value > 0);

    return nextValue || maximumAllowed;
};
